import Timeline from '@/models/Timeline'
import { CollectionTransformer } from '@/transformers/index'
import { JourneyTransformer } from '@/transformers/JourneyTransformer'
import { TimelineBlockTransformer } from '@/transformers/TimelineBlockTransformer'

export class TimelineTransformer {
    constructor (
        collectionTransformer = new CollectionTransformer(),
        journeyTransformer = new JourneyTransformer(),
        timelineBlockTransformer = new TimelineBlockTransformer()
    ) {
        this.collectionTransformer = collectionTransformer
        this.journeyTransformer = journeyTransformer
        this.timelineBlockTransformer = timelineBlockTransformer
    }

    transform (data) {
        return new Timeline(
            data.startTime,
            data.endTime,
            this.collectionTransformer.transform(this.timelineBlockTransformer, data.timelineBlocks),
            this.collectionTransformer.transform(this.journeyTransformer, data.journeys)
        )
    }
}
